'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

define('animation', ['element'], function (elementHelper) {
  'use strict';

  /**
   * Animation methods
   */

  return {

    element: new elementHelper(),

    /**
     * Fades DOM element out
     * @param {object} element
     * @param {function} [callback]
     */
    fadeOut: function fadeOut(element, callback) {
      if (!element || !this.element.isDomElement(element)) {
        console.warn('This function expects to use one DOM element', 'Got' + (typeof element === 'undefined' ? 'undefined' : _typeof(element)), 'fadeOut');
        return;
      }

      element.style.opacity = 1;
      var interval = setInterval(function () {
        element.style.opacity = element.style.opacity - 0.02;
        if (element.style.opacity <= 0.1) {
          element.style.opacity = 0;
          clearInterval(interval);
          if (callback) {
            callback(element);
          }
        }
      }, 10);
    },

    /**
     * Fades DOM element in
     * @param {object} element
     * @param {function} [callback]
     */
    fadeIn: function fadeIn(element, callback) {
      if (!element || !this.element.isDomElement(element)) {
        console.warn('This function expects to use one DOM element', 'Got' + (typeof element === 'undefined' ? 'undefined' : _typeof(element)), 'fadeIn');
        return;
      }

      var opacity = 0;
      var interval = setInterval(function () {
        opacity = opacity + 0.02;
        element.style.opacity = opacity;
        if (element.style.opacity >= 0.9) {
          element.style.opacity = 1;
          clearInterval(interval);
          if (callback) {
            callback(element);
          }
        }
      }, 10);
    }
  };
});
//# sourceMappingURL=animation.js.map
